import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';
import { ParkingEnterpriseSearchInterface } from '@sabstravtech/obtservices/base';
import { Component, Input } from '@angular/core';

import { ProductLoadingScreen } from './product-loading-screen';

@Component({
  selector: 'app-parking-loading-screen',
  templateUrl: './parking-loading-screen.component.html',
  styleUrls: [],
  standalone: false
})
export class ParkingLoadingScreenComponent extends ProductLoadingScreen<ParkingEnterpriseSearchInterface> {
  @Input() animated = true;
  constructor(service: EnterpriseSearchService) {
    super(service, service.searches[ServiceType.Parking]);
  }
}
